// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChangeImageContainer_j9bC0 {
  input[type="file"] {
    display: none;
  }
}
.imageContainer_Yoe7b {
  position: relative;
  width: fit-content;
  height: fit-content;
  box-sizing: border-box;
  display: flex;
  img {
    height: 100px;
    width: 100px;
    object-fit: cover;
    box-sizing: border-box;
  }
  .optionsImage_jqGlz {
    position: absolute;
    display: none;
    bottom: 0px;
    width: 100%;
    height: 30px;
    gap: 10px;
    justify-content: center;
    align-items: center;
    background: var(--Grey-500, var(--9e9e9e-background));
    svg {
      cursor: pointer;
      height: 15px;
      width: 15px;
      &:nth-child(2) {
        height: 20px;
        width: 20px;
      }
    }
  }

  &:hover {
    .optionsImage_jqGlz {
      display: flex;
    }
  }
}
.rounded_RqMBD {
  overflow: hidden;
  border-radius: 9999px;
  -webkit-border-radius: 9999px;
  -moz-border-radius: 9999px;
  -ms-border-radius: 9999px;
  -o-border-radius: 9999px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/ChangeImage/ChangeImage.module.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb;IACE,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,YAAY;IACZ,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,qDAAqD;IACrD;MACE,eAAe;MACf,YAAY;MACZ,WAAW;MACX;QACE,YAAY;QACZ,WAAW;MACb;IACF;EACF;;EAEA;IACE;MACE,aAAa;IACf;EACF;AACF;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;AAC1B","sourcesContent":[".ChangeImageContainer {\n  input[type=\"file\"] {\n    display: none;\n  }\n}\n.imageContainer {\n  position: relative;\n  width: fit-content;\n  height: fit-content;\n  box-sizing: border-box;\n  display: flex;\n  img {\n    height: 100px;\n    width: 100px;\n    object-fit: cover;\n    box-sizing: border-box;\n  }\n  .optionsImage {\n    position: absolute;\n    display: none;\n    bottom: 0px;\n    width: 100%;\n    height: 30px;\n    gap: 10px;\n    justify-content: center;\n    align-items: center;\n    background: var(--Grey-500, var(--9e9e9e-background));\n    svg {\n      cursor: pointer;\n      height: 15px;\n      width: 15px;\n      &:nth-child(2) {\n        height: 20px;\n        width: 20px;\n      }\n    }\n  }\n\n  &:hover {\n    .optionsImage {\n      display: flex;\n    }\n  }\n}\n.rounded {\n  overflow: hidden;\n  border-radius: 9999px;\n  -webkit-border-radius: 9999px;\n  -moz-border-radius: 9999px;\n  -ms-border-radius: 9999px;\n  -o-border-radius: 9999px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ChangeImageContainer": `ChangeImageContainer_j9bC0`,
	"imageContainer": `imageContainer_Yoe7b`,
	"optionsImage": `optionsImage_jqGlz`,
	"rounded": `rounded_RqMBD`
};
export default ___CSS_LOADER_EXPORT___;
